<div class="notification-bell-wrapper">
    <button
        type="button"
        class="notification-bell-button"
        [class.has-notifications]="unreadCount() > 0"
        [class.has-urgent]="hasUrgentNotifications()"
        (click)="op.toggle($event)"
        [attr.aria-label]="'Notifications - ' + (unreadCount() > 0 ? unreadCount() + ' unread' : 'No unread messages')"
        role="button"
        tabindex="0"
    >
        <div class="bell-icon-container">
            <i class="pi pi-bell"></i>
            @if (unreadCount() > 0) {
                <span class="notification-badge" [class.has-many]="unreadCount() > 9">
                    {{ unreadCount() > 99 ? '99+' : unreadCount() }}
                </span>
                <span class="notification-pulse"></span>
            }
        </div>
    </button>

    <p-overlayPanel 
        #op 
        [style]="{ width: '440px', maxHeight: '640px' }" 
        [dismissable]="true" 
        styleClass="notification-panel"
        [showTransitionOptions]="'0.15s cubic-bezier(0, 0, 0.2, 1)'"
        [hideTransitionOptions]="'0.1s cubic-bezier(0.4, 0, 1, 1)'"
    >
        <ng-template pTemplate="content">
            <div class="notification-header">
                <div class="header-left">
                    <h3 class="notification-title">Notifications</h3>
                    @if (unreadCount() > 0) {
                        <span class="unread-count-badge">{{ unreadCount() }} new</span>
                    }
                </div>
                <div class="notification-actions">
                    <a
                        routerLink="/notifications"
                        class="action-button"
                        (click)="op.hide()"
                        title="View all notifications"
                        aria-label="View all notifications in full page"
                    >
                        <i class="pi pi-window-maximize"></i>
                    </a>
                </div>
            </div>

            @if (recentNotifications().length === 0) {
                <div class="empty-state">
                    <div class="empty-illustration">
                        <div class="empty-icon-bg">
                            <i class="pi pi-bell"></i>
                        </div>
                        <div class="empty-sparkles">
                            <span class="sparkle sparkle-1">✨</span>
                            <span class="sparkle sparkle-2">✨</span>
                            <span class="sparkle sparkle-3">✨</span>
                        </div>
                    </div>
                    <p class="empty-text">All caught up!</p>
                    <p class="empty-subtext">No new notifications. You're doing great! 🎉</p>
                </div>
            } @else {
                <div class="notifications-list">
                    @for (notification of recentNotifications(); track notification.id; let i = $index) {
                        <div
                            class="notification-card"
                            [class.unread]="!notification.isRead"
                            [attr.data-priority]="notification.priority"
                            [style.animation-delay]="(i * 0.05) + 's'"
                            (click)="handleNotificationClick(notification, op)"
                            role="button"
                            tabindex="0"
                            [attr.aria-label]="notification.title + '. ' + notification.message"
                        >
                            <div class="notification-glow" [attr.data-priority]="notification.priority"></div>
                            <div class="notification-icon-wrapper" [attr.data-priority]="notification.priority">
                                <i [ngClass]="getNotificationIcon(notification.type)"></i>
                            </div>
                            <div class="notification-content">
                                <div class="notification-header-row">
                                    <h4 class="notification-card-title">
                                        {{ notification.title }}
                                        @if (!notification.isRead) {
                                            <span class="unread-indicator" aria-label="Unread"></span>
                                        }
                                    </h4>
                                </div>
                                <p class="notification-message">{{ notification.message }}</p>
                                @if (notification.actionUrl) {
                                    <a 
                                        [routerLink]="notification.actionUrl" 
                                        class="notification-action-url"
                                        (click)="$event.stopPropagation(); op.hide()"
                                        title="Navigate to {{ notification.actionUrl }}"
                                    >
                                        <i class="pi pi-link"></i>
                                        <span class="action-url-text">{{ notification.actionUrl }}</span>
                                        <i class="pi pi-arrow-right action-arrow"></i>
                                    </a>
                                }
                                <div class="notification-meta">
                                    <span class="notification-time">
                                        <i class="pi pi-clock"></i>
                                        {{ getTimeAgo(notification.createdAt) }}
                                    </span>
                                    @if (notification.priority === 'urgent' || notification.priority === 'high') {
                                        <span class="priority-pill" [attr.data-priority]="notification.priority">
                                            {{ notification.priority }}
                                        </span>
                                    }
                                </div>
                            </div>
                            <div class="notification-chevron">
                                <i class="pi pi-chevron-right"></i>
                            </div>
                        </div>
                    }
                </div>
                <div class="notification-footer">
                    <a routerLink="/notifications" (click)="op.hide()" class="view-all-link">
                        <span>View all {{ recentNotifications().length > 5 ? recentNotifications().length : '' }} notifications</span>
                        <i class="pi pi-arrow-right"></i>
                    </a>
                </div>
            }
        </ng-template>
    </p-overlayPanel>
</div>

